import * as  React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as _ from 'lodash';
import * as actions from '../../../../redux/projects/actions.projects';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import platformNames from '../../../../const/platformNames';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { IProject } from '../../../../models/IProject';
import ToasterService from '../../../../services/ToasterService';
import ReactTooltip from 'react-tooltip';
import FilterSwitcher from '../../../components/FilterSwitcher/FilterSwitcher';
import { ICohort } from '../../../../models/ICohort';
import { getBoolOption, getStringOption } from '../getProjectOptions';
import { getProjectOptionsByEnvironment } from '../../../../services/mini/getProjectOptionsByEnvironment';
import { KEEP_MICROPHONE_IN_BACKGROUND_OPT_LABEL, WAKE_WORD_ENABLED_OPT_KEY, WAKE_WORD_ENABLED_OPT_KEY_OLD, WAKE_WORD_ENABLED_OPT_LABEL, WAKE_WORD_IN_BACKGROUND_OPT_KEY, WAKE_WORD_IN_BACKGROUND_OPT_KEY_OLD, WAKE_WORD_IN_BACKGROUND_OPT_LABEL, WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY, WAKE_WORD_PATH_OPT_KEY } from '../defaultProjectOptions';
import { IStore } from '../../../../redux/initialState';
import { validateWakeWordPath } from '../../../../services/validations/validateWakeWordPath';
import { Environment } from '../../../../const/environment';
import WakeWordForm from '../WakeWord/WakeWordForm/WakeWordForm';
import ComboBox from '../../../components/ComboBox/ComboBox';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import { WakeWordOptionsItem } from '../WakeWord/WakeWordOptionsItem/WakeWordOptionsItem';
import { IWakeWord } from '../../../../models/IWakeWord';
import messages from '../../../../const/messages';
import WakeWordPreview from '../WakeWord/WakeWordPreview/WakeWordPreview';
import { getSelectedWakeWordIdByModelUrl } from '../../../../services/mini/getSelectedWakeWordIdByModelUrl';
import InlineEditor from '../../../components/InlineEditor/InlineEditor';
import { toogleBooleanOption } from '../../../../services/mini/toogleBooleanOption';


type WakeWordOptionsProps = PropsFromRedux & {
    projectId: string
    project: IProject
    environment: Environment
    platform: string
    optionsMode: boolean
    selectedCohortId: string
    cohorts: ICohort[]
    onClose: () => void
};

type WakeWordOptionsState = {
    [WAKE_WORD_ENABLED_OPT_KEY]: boolean
    [WAKE_WORD_PATH_OPT_KEY]: string
    [WAKE_WORD_IN_BACKGROUND_OPT_KEY]: boolean,
    [WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY]: string,
    wakeWordEditMode: boolean,
    wakeWordToUpdate: IWakeWord | null,
    wakeWordToDelete: IWakeWord | null,
}

class WakeWordOptions extends React.Component<WakeWordOptionsProps, WakeWordOptionsState> {

    _isMounted: boolean;

    constructor(props) {
        super(props);

        this.state = {
            ...this.fillState(props),
        };
    }


    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fillState = (props) => {
        return {
            [WAKE_WORD_ENABLED_OPT_KEY]: getBoolOption(props, WAKE_WORD_ENABLED_OPT_KEY, WAKE_WORD_ENABLED_OPT_KEY_OLD),
            [WAKE_WORD_IN_BACKGROUND_OPT_KEY]: getBoolOption(props, WAKE_WORD_IN_BACKGROUND_OPT_KEY, WAKE_WORD_IN_BACKGROUND_OPT_KEY_OLD),
            [WAKE_WORD_PATH_OPT_KEY]: getStringOption(props, WAKE_WORD_PATH_OPT_KEY),
            [WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY]: getStringOption(props, WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY),
            wakeWordEditMode: false,
            wakeWords: null,
            wakeWordToUpdate: null,
            wakeWordToDelete: null,
        };
    }

    validateWakeWordPath = (wakeWordPath) => {
        const error = validateWakeWordPath(wakeWordPath);

        if (error) {
            return {
                error
            };
        }

        return {};
    }

    onSaveWakeWordPath = (newWakeWord) => {
        this.setState({ [WAKE_WORD_PATH_OPT_KEY]: newWakeWord }, () => {
            this.setWakeWordPathOption();
        });
    }

    setWakeWordPathOption = () => {
        const {
            project,
            platform,
            environment,
            cohorts,
            selectedCohortId,
            setProjectOptions
        } = this.props;

        const wakeWordPath = this.state[WAKE_WORD_PATH_OPT_KEY];

        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

        if (_.get(options[platform], WAKE_WORD_PATH_OPT_KEY) === wakeWordPath) {
            return;
        }

        options[platform] = _.set(options[platform], WAKE_WORD_PATH_OPT_KEY, wakeWordPath);

        setProjectOptions({ project, options, environment, cohorts, selectedCohortId }).then(() => {
            ToasterService.showInfo({ title: 'Wake word path was saved.' });
        });
    }

    setWakeWord = (wakeWordInfo: IWakeWord, hideTooltip?: boolean) => {
        const {
            project,
            platform,
            environment,
            cohorts,
            selectedCohortId,
            setProjectOptions,
            wakeWords
        } = this.props;

        const wakeWordModelUrl = this.state[WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY];

        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

        const wakeWordModelUrlFromOptions = _.get(options[platform], WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY);

        if (wakeWordModelUrlFromOptions === wakeWordModelUrl) {
            return;
        }

        return new Promise<void>((resolve, reject) => {
            try {
                const wakeWordOptions = JSON.parse(wakeWordInfo.options);
                options[platform] = _.set(options[platform], WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY, wakeWordOptions.model_url);

                setProjectOptions({ project, options, environment, cohorts, selectedCohortId }).then(() => {
                    resolve();
                    if (!hideTooltip) {
                        ToasterService.showInfo({ title: 'Wake word was saved.' });
                    }
                });
            } catch (err) {
                ToasterService.showError({ title: 'We were not able to parse wake word model. Please, contact support.' });
                reject();
            }
        });
    }

    setWakeWordInBackground = () => {
        const wakeWordInBackground = this.state[WAKE_WORD_IN_BACKGROUND_OPT_KEY];

        if (!wakeWordInBackground) {
            this.saveProjectOptions({
                keepMicrophoneInBackground: true,
                [WAKE_WORD_ENABLED_OPT_KEY]: true,
                [WAKE_WORD_IN_BACKGROUND_OPT_KEY]: true,
                [WAKE_WORD_ENABLED_OPT_KEY_OLD]: true,
                [WAKE_WORD_IN_BACKGROUND_OPT_KEY_OLD]: true
            });
            ToasterService.showInfo({ title: 'With this option turned on, the <span class="highlighted-item-in-toast">' + KEEP_MICROPHONE_IN_BACKGROUND_OPT_LABEL + '</span> and <span  class="highlighted-item-in-toast">' + WAKE_WORD_ENABLED_OPT_LABEL + '</span> options are enabled.' });
        } else {
            this.toggleBoolOption(WAKE_WORD_IN_BACKGROUND_OPT_KEY, WAKE_WORD_IN_BACKGROUND_OPT_KEY_OLD);
        }
    }

    setWakeWordSettings = () => {
        const { wakeWords } = this.props;
        const wakeWordEnabled = this.state[WAKE_WORD_ENABLED_OPT_KEY];
        const selectedWakeWordId = getSelectedWakeWordIdByModelUrl(wakeWords, this.state[WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY]);

        if (wakeWordEnabled) {
            this.saveProjectOptions({
                [WAKE_WORD_ENABLED_OPT_KEY]: false,
                [WAKE_WORD_IN_BACKGROUND_OPT_KEY]: false,
                [WAKE_WORD_ENABLED_OPT_KEY_OLD]: false,
                [WAKE_WORD_IN_BACKGROUND_OPT_KEY_OLD]: false,
            });
        } else {
            this.toggleBoolOption(WAKE_WORD_ENABLED_OPT_KEY, WAKE_WORD_ENABLED_OPT_KEY_OLD).then(() => {
                if (!selectedWakeWordId) {
                    this.changeWakeWordId(this.props.defaultWakeWord, true);
                }
            });
        }
    }

    toggleBoolOption = (optionName, optionNameOld?) => {
        return toogleBooleanOption(this.props, this.state[optionName], (newVal) => {
            this.setState({ [optionName]: newVal } as WakeWordOptionsState);
        }, false, optionName, optionNameOld);
    }

    saveProjectOptions(newOptions) {
        const {
            project,
            platform,
            environment,
            cohorts,
            selectedCohortId,
            setProjectOptions
        } = this.props;
        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);
        const keys = Object.keys(newOptions);

        for (let i = 0; i < keys.length; i++) {
            const optionName = keys[i];
            options[platform] = _.set(options[platform], optionName, newOptions[optionName]);
        }
        this.setState(newOptions);
        setProjectOptions({ project, options, environment, cohorts, selectedCohortId });
    }

    createWakeWord = () => {
        this.setState({
            wakeWordEditMode: true
        });
    }

    closeWakeWordModelForm = () => {
        this.setState({
            wakeWordEditMode: false,
            wakeWordToUpdate: null
        });
    }

    onWakeWordModelSaved = async (wakeWord: IWakeWord) => {
        const { getWakeWords, projectId } = this.props;
        await getWakeWords({ projectId });
        await this.changeWakeWordId(wakeWord, true);
        this.closeWakeWordModelForm();
    }

    changeWakeWordId = (wakeWord: IWakeWord, hideTooltip?: boolean) => {
        return new Promise<void>((resolve) => {
            this.setState({
                [WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY]: JSON.parse(wakeWord.options).model_url,
                wakeWordToUpdate: null
            }, async () => {
                await this.setWakeWord(wakeWord, hideTooltip);
                resolve();
            });
        });
    }

    updateWakeWord = (wakeWordInfo: IWakeWord) => {
        this.setState({ wakeWordEditMode: true, wakeWordToUpdate: wakeWordInfo });
    }

    deleteWakeWord = (wakeWordInfo: IWakeWord) => {
        this.setState({ wakeWordToDelete: wakeWordInfo });
    }

    render() {
        const {
            customWakeWordAvailable,
            customWakeWord3Available,
            projectId,
            project,
            platform,
            onClose,
            wakeWords,
            defaultWakeWord
        } = this.props;

        const wakeWordInBackground = this.state[WAKE_WORD_IN_BACKGROUND_OPT_KEY];
        const wakeWordEnabled = this.state[WAKE_WORD_ENABLED_OPT_KEY];
        const wakeWordPath = this.state[WAKE_WORD_PATH_OPT_KEY];
        const selectedWakeWordId = getSelectedWakeWordIdByModelUrl(wakeWords, this.state[WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY]) || defaultWakeWord?.id;
        const {
            wakeWordEditMode,
            wakeWordToDelete,
            wakeWordToUpdate
        } = this.state;

        const customWakeWordIsNotAvailableTooltip = messages.customWakeWordFeatureNotAvailable;
        const wakeWord3IsAvailable = wakeWordEnabled && customWakeWord3Available;
        const wakeWord2IsAvailable = wakeWordEnabled && customWakeWordAvailable;

        const currentWakeWord = _.find(wakeWords, { id: selectedWakeWordId });

        return <PopupWrapper className="wake-word-options alan-button-options">
            <div className="wake-word-options_external-wrapper">
                <div className="popup-form_header popup-form_header_with-commands">
                    <div className={`popup-form_header_cmd ${wakeWordEditMode && 'disappear'}`}
                        onClick={onClose}>
                        <i className="icon icon-alan-chevron"
                            style={{
                                transform: 'rotate(90deg)',
                                display: 'inline-block',
                                marginRight: '5px'
                            }} />
                        Back
                    </div>
                    <div>{`${platformNames[platform]} - Wake word`}</div>
                    <div className="popup-form_header_cmd" />
                </div>
                <div className="popup-form_internal-wrapper wake-word-options_internal-wrapper">

                    <div className="wake-word-options_content">
                        {!wakeWordEditMode &&
                            <div className="alan-button-options_table no-bottom-margin">
                                <div className="alan-button-options_table_column">
                                    <div className="alan-button-options_table_row">
                                        <div className={`alan-button-options_wake-word`}
                                            data-place="top"
                                            data-multiline="true"
                                            data-effect="solid"
                                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                            data-for="wakeWordSettings"
                                            data-tip={'Activates the voice assistant when the user says a wake word'}>
                                            <FilterSwitcher
                                                labelIfTrue={WAKE_WORD_ENABLED_OPT_LABEL}
                                                labelIfFalse={WAKE_WORD_ENABLED_OPT_LABEL}
                                                offMode={true}
                                                minWidth="100%"
                                                maxWidth="100%"
                                                labelOnLeftSide={true}
                                                onClick={this.setWakeWordSettings}
                                                value={wakeWordEnabled} />
                                            <ReactTooltip id="wakeWordSettings" />
                                        </div>
                                    </div>
                                </div>
                                <div className="alan-button-options_table_column-sep" />
                                <div className="alan-button-options_table_column">
                                    <div className="alan-button-options_table_row">
                                        <div className={`alan-button-options_wake-word-in-background`}
                                            data-place="top"
                                            data-multiline="true"
                                            data-effect="solid"
                                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                            data-for="wakeWordInBackgroundSettings"
                                            data-tip="Allows using the wake word in the background">
                                            <FilterSwitcher
                                                labelIfTrue={WAKE_WORD_IN_BACKGROUND_OPT_LABEL}
                                                labelIfFalse={WAKE_WORD_IN_BACKGROUND_OPT_LABEL}
                                                offMode={true}
                                                minWidth="100%"
                                                maxWidth="100%"
                                                labelOnLeftSide={true}
                                                onClick={this.setWakeWordInBackground}
                                                value={wakeWordInBackground} />
                                            <ReactTooltip id="wakeWordInBackgroundSettings" />
                                        </div>
                                    </div>
                                </div>
                            </div>}


                        {wakeWordEditMode ?
                            <WakeWordForm
                                projectId={projectId}
                                updateMode={!!wakeWordToUpdate}
                                wakeWord={wakeWordToUpdate || currentWakeWord}
                                onAfterSave={this.onWakeWordModelSaved}
                                onCancel={this.closeWakeWordModelForm}
                                wakeWords={wakeWords}
                            /> :
                            <React.Fragment>
                                <div className="alan-button-options_table no-bottom-margin">
                                    <div className="alan-button-options_table_one-column">

                                        {customWakeWord3Available &&
                                            <React.Fragment>
                                                {customWakeWord3Available && <div className="alan-button-style-form_block-header">
                                                    <div className="wake-word-options_saved-options-controls">
                                                        <div>
                                                            Wake word
                                                        </div>
                                                        {wakeWords && <ComboBox
                                                            values={customWakeWord3Available ? wakeWords : [defaultWakeWord]}
                                                            valueKey="id"
                                                            valueName="name"
                                                            classes={` ${!wakeWordEnabled && 'disabled'}`}
                                                            selectedValueId={selectedWakeWordId}
                                                            onValueSelect={this.changeWakeWordId}
                                                            renderItem={(wakeWordItem, inList, closeComboBoxCb) => {
                                                                return <WakeWordOptionsItem
                                                                    selectedWakeWordId={selectedWakeWordId}
                                                                    project={project}
                                                                    onItemCopy={(item, e) => {
                                                                        this.updateWakeWord(item);
                                                                    }}
                                                                    onItemDelete={(item, e) => {
                                                                        this.deleteWakeWord(item);
                                                                        closeComboBoxCb(e);
                                                                    }}
                                                                    wakeWordItem={wakeWordItem}
                                                                />;
                                                            }} />}
                                                        <div className={`action-btn alan-button-style-form_btn create-custom-wakeword-btn ${!wakeWord3IsAvailable && 'disabled'}`}
                                                            onClick={this.createWakeWord}>
                                                            Create custom wake word
                                                        </div>
                                                        {!customWakeWord3Available && <i
                                                            className="icon icon-alan-help-sign"
                                                            data-for="customWakeWordIsNotAvailable"
                                                            data-tip={customWakeWordIsNotAvailableTooltip}
                                                            data-place="bottom"
                                                            data-effect="solid"
                                                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-340" />}
                                                        <ReactTooltip id="customWakeWordIsNotAvailable" />
                                                    </div>
                                                </div>}
                                                <div className={`wake-word-options_info ${wakeWordEnabled && 'disappear'}`}>
                                                    <i className="icon icon-alan-info-sign" />
                                                    To configure wake word settings and create custom wake words, enable the Wake word option above
                                                </div>
                                                <div>
                                                    {(currentWakeWord && !currentWakeWord.isPredefined) &&
                                                        <WakeWordPreview
                                                            key={selectedWakeWordId}
                                                            wakeWord={currentWakeWord}
                                                        />}
                                                </div>
                                            </React.Fragment>}

                                        {customWakeWordAvailable &&
                                            <React.Fragment>
                                                <div className="alan-button-options_table_row wake-word-options_wake-word-row">
                                                    <div className={`alan-button-options_wake-word-path`}
                                                        data-place="bottom"
                                                        data-multiline="true"
                                                        data-effect="solid"
                                                        data-offset="{'top': -20}"
                                                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240 wake-word-path-tooltip"
                                                        data-for="wakeWordPathSettings"
                                                        data-tip={customWakeWordAvailable ? `Sets the wake word path url` : 'Custom WakeWord is unavailable on your plan. Change your plan to get full access to this feature'}>
                                                        <span className="alan-button-options_wake-word-path_label">Set custom wake word path</span>

                                                        <div className="alan-button-options_wake-word-path_input-wrapper">
                                                            <InlineEditor
                                                                key={wakeWordPath}
                                                                withBorder={true}
                                                                value={customWakeWordAvailable ? wakeWordPath : '-'}
                                                                readOnly={!wakeWord2IsAvailable}
                                                                autoFocus={true}
                                                                validate={this.validateWakeWordPath}
                                                                exitEditModeAfterConfirm={true}
                                                                confirmAction={(newWakeWord) => {
                                                                    this.onSaveWakeWordPath(newWakeWord);
                                                                }} />
                                                        </div>
                                                    </div>
                                                    <div className={`wake-word-options_info-for-custum-wakeword-path ${wakeWordEnabled && 'disappear'}`}>
                                                        <i className="icon icon-alan-info-sign" />
                                                        To configure custom wake word path, enable the Wake word option above
                                                    </div>
                                                </div>
                                            </React.Fragment>}
                                    </div>
                                </div>
                            </React.Fragment>}

                    </div>
                </div>
                {wakeWordToDelete &&
                    <div className="alan-button-style-form_overlay">
                        <ConfirmPopup
                            externalLayerClass="delete-btn-options-confirm-dialog"
                            onClose={(e) => {
                                this.setState({ wakeWordToDelete: null });
                            }}
                            okBtnLabel="Delete"
                            okBtnCb={() => {
                                const { wakeWordToDelete } = this.state;
                                this.props.deleteWakeWord({
                                    projectId,
                                    wakeWordId: wakeWordToDelete.id
                                });
                                this.setState({ wakeWordToDelete: null });
                            }}
                            title="Delete Version"
                            message={<div>Are you sure you want to delete <b>{wakeWordToDelete.name}</b>?</div>} />
                    </div>}
            </div>
        </PopupWrapper>;
    }
}

function mapStateToProps({ projectsInfo, user }: IStore) {
    return {
        isProjectOptionsSaving: projectsInfo.isProjectOptionsSaving,
        defaultWakeWord: projectsInfo.currentProject.defaultWakeWord,
        wakeWords: projectsInfo.currentProject.wakeWords,
        customWakeWordAvailable: user.capabilities.customWakeWordAvailable,
        customWakeWord3Available: user.capabilities.customWakeWord3Available
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setProjectOptions: (param) => asyncDispatch(actions.setProjectOptions, dispatch, param),
        getButtonOptions: (param) => asyncDispatch(actions.getButtonOptions, dispatch, param),
        getWakeWords: (param) => asyncDispatch(actions.getWakeWords, dispatch, param),
        deleteWakeWord: (param) => asyncDispatch(actions.deleteWakeWord, dispatch, param),
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(WakeWordOptions);

